<template>
  <div v-if="authorized">
    <!-- Module view -->
    <q-item
        v-if="mode === 'module'"
        @click="goTo(to)"
        exact
        active-class="tab-active"
        class="q-ma-sm navigation-item"
        clickable
        v-ripple
        :inset-level="depth"
    >
      <q-item-section avatar>
        <q-icon size="xs" :name="icon" />
      </q-item-section>

      <q-item-section>
        <q-item-label>{{ $t(label) }}</q-item-label>
        <q-item-label caption>{{ description ? $t(description) : "" }}</q-item-label>
      </q-item-section>
    </q-item>

    <!-- Tree view -->
    <q-expansion-item
        v-else
        :header-inset-level="depth"
        :icon="icon"
        :label="$t(label)"
        @click="goTo(to)"
    >
      <template v-for="(node, idx) in nodes" :key="idx">
        <!-- Recursive nodes -->
        <tree-menu
            v-if="node.nodes?.length"
            v-bind="node"
            :depth="depth+0.5"
        />
        <!-- Leaf nodes -->
        <q-item
            v-else
            class="q-ma-sm navigation-sub-item"
            @click="goTo(node.to)"
            exact
            active-class="tab-active"
            clickable
            v-ripple
            :inset-level="depth+0.5"
        >
          <q-item-section avatar>
            <q-icon size="xs" :name="node.icon" />
          </q-item-section>

          <q-item-section>
            <q-item-label>{{ $t(node.label) }}</q-item-label>
            <q-item-label caption>{{ node.description ? $t(node.description) : "" }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-expansion-item>
  </div>
</template>

<script>
import {mapStores} from "pinia";
import {useLayoutStore} from "stores/layoutStore";
import {useAuthStore} from "stores/authStore";
import NavigationService from "src/services/navigationService";

export default {
  name: "tree-menu",

  props: {
    label: { type: String, required: true },
    description: { type: String, default: "" },
    nodes: { type: Array, default: () => [] },
    depth: { type: Number, default: 0 },
    icon: { type: String, required: true },
    to: { type: String, default: "" },
    mode: { type: String, required: true },
    authorized: { type: Boolean, default: true }
  },

  computed: {
    ...mapStores(useLayoutStore, useAuthStore)
  },

  methods: {
    goTo(to) {
      if (!to) return;

      NavigationService.pushTo(to);

      if (this.layoutStore.isMobile) {
        this.layoutStore.toggleLeftSideState();
      }
    }
  }
};
</script>

<style lang="scss">
.navigation-sub-item {
  border-radius: 5px;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  font-size: 14px;
}

.tab-active {
  background-color: $pappus !important;
}
</style>
